/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

/**
 * Base URL for the Karya Evals Platform.
 * Fixed to the production endpoint.
 */
/*
rsync -avz --delete dist karya@evals.karya.in:/var/www/samiksha --progress --rsync-path="sudo rsync"
*/
export const EVALS_PLATFORM_URL = 'https://evals.karya.in/';

